import 'channels/responses_channel.js';
import 'src/js/application/convince.js';
import 'src/js/application/index.js';